<div class="onboarding-container d-flex flex-column justify-content-center align-items-center" [ngStyle]="backgroundStyle">
    <div *ngIf="isLogoShown && !isFullScreen" class="mt-20 logo d-flex justify-content-center align-items-center">
      <div class="icon"></div>
      <div class="name ms-10">FemSecret</div>
    </div>
    <div class="flow-container d-flex flex-column" [class.full-screen]="isFullScreen">
      <router-outlet></router-outlet>
    </div>
</div>
  